module.exports = __webpack_public_path__ + "img/logo-dark.c45c9225.svg";